import React, { useEffect } from 'react';
import { Header } from './components/Header/Header';
import { Container, Content, Footer, Wrapper } from './FormRisk.styles';
import { CheckboxSection } from './components/CheckboxSection/CheckboxSection';
import { FormElements } from './components/FormElements/FormElements';
import { Button } from '@welbe/design-system';
import { useFormRisk } from './FormRisk.hooks';
import { ContentSkeleton } from './components/ContentSkeleton/ContentSkeleton';
import { ErrorScreen } from './components/ErrorScreen/ErrorScreen';
import { FinishModal } from './components/FinishModal/FinishModal';

export const FormRisk = () => {
	const {
		steps,
		active,
		complete,
		riskIndex,
		stepperLoading,
		formLoading,
		isLastForm,
		focusedId,
		isLoading,
		riskFormsTypes,
		jobRiskFactors,
		isProfileError,
		openFinishModal,
		closeFinishModal,
		handleRefresh,
		handleNavigate,
		handleNext,
		handlePrev,
	} = useFormRisk();

	useEffect(() => {
		const element = document.getElementById('AppLayoutCompanies');
		if (element) {
			element.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
		}
	}, [active]);

	if (isProfileError) {
		return <ErrorScreen onRefresh={handleRefresh} />;
	}

	return (
		<>
			<FinishModal open={openFinishModal} close={closeFinishModal} />
			<Wrapper>
				<Container>
					<Header
						steps={steps}
						active={active}
						complete={complete}
						loading={stepperLoading}
						onNavigate={handleNavigate}
					/>
					<ContentSkeleton loading={formLoading} />
					<Content loading={formLoading} key={active}>
						<CheckboxSection steps={steps} jobRiskFactors={jobRiskFactors} />
						<FormElements
							key={focusedId}
							steps={steps}
							riskFormsTypes={riskFormsTypes}
							jobRiskFactor={jobRiskFactors[riskIndex]}
						/>
						{isProfileError && <div>Error</div>}
					</Content>
				</Container>
				<Footer>
					<Button
						id="form-risk-back-button"
						width="220px"
						variant="outline"
						onClick={handlePrev}
						disabled={isLoading}
					>
						Regresar
					</Button>
					<Button
						id="form-risk-next-button"
						width="220px"
						loading={isLoading}
						onClick={handleNext}
					>
						{isLastForm ? 'Finalizar' : 'Continuar'}
					</Button>
				</Footer>
			</Wrapper>
		</>
	);
};
